export const STATUS_CODE = {
  SES_DOMAIN_NOT_VERIFIED: 406,
  DUPLICATE_NAME_AND_EMAIL: 409,
  EXCEEDED_CREATE_LIMIT: 422,
}
